import { Component, Input,  OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { KeyModel } from  '@models/keyModel.model'
import { AmKeyboardService } from "@components/am-keyboard/am-keyboard.service";

/**
 * Componente que representa una tecla personalizada para un teclado virtual.
 * Este componente permite interactuar con un teclado virtual y manejar la entrada de datos en un campo de formulario.
 */
@Component({
    selector: 'app-am-key',
    templateUrl: './am-key.component.html',
    styleUrls: ['./am-key.component.scss'],
    standalone: false
})
export class AmKeyComponent implements OnInit {
/**
   * Modelo de la tecla que define su comportamiento y apariencia.
   *
   * @type {KeyModel}
   */
@Input() key: KeyModel;

/**
 * Tipo de tecla (por ejemplo, 'number' para teclas numéricas o 'text' para teclas de texto).
 *
 * @type {string}
 * @default 'number'
 */
@Input() type: string = 'number';

/**
 * Referencia al elemento HTML input asociado a la tecla.
 *
 * @type {HTMLElement}
 */
@Input() reference: HTMLElement;

/**
 * Control de formulario asociado a la tecla.
 *
 * @type {UntypedFormControl}
 */
@Input() currentFormCtr: UntypedFormControl;

/**
 * Indica si el tema del teclado es oscuro.
 *
 * @type {boolean}
 * @default false
 */
@Input() isDarkTheme = false;

/**
 * Control de formulario actual asociado a la tecla.
 *
 * @type {UntypedFormControl}
 */
currentCtrl: UntypedFormControl;

  constructor(
      private keyboarServ: AmKeyboardService
  ) { }

  ngOnInit(): void {
    this.currentCtrl = this.currentFormCtr;

  }
 /**
   * Método que se ejecuta cuando se presiona una tecla.
   * Valida la tecla presionada y actualiza el valor del campo de entrada asociado.
   *
   * @param {KeyModel} key - Tecla presionada.
   * @return {void} No retorna ningún valor.
   */
  onPressKey(key: KeyModel): void {
    const inputValue = (<HTMLInputElement>this.reference);
    this.currentCtrl = this.currentFormCtr;

    if (this.reference){
      if(key){
        this.validateKey(key.key, inputValue);
      }
    }
  }
  /**
   * Método que devuelve la clase CSS correspondiente a una tecla en función de su tipo y comportamiento.
   *
   * @param {KeyModel} key - Tecla para la cual se determina la clase CSS.
   * @return {string} Clase CSS correspondiente a la tecla.
   */
  getClass(key: KeyModel): string {
    let cssClass = '';

    if (this.type === 'text') {
      switch (key.key) {
        case '':
        case '\n':
          cssClass = "am-width-medium-half";
          break;
        case 'space':
          cssClass = "am-space";
          break;
        case '\r':
        case '\tr':
          cssClass = "am-width-double";
          break;
        case 'aux1':
          cssClass = "am-aux1";
          break;
        case 'aux2':
          cssClass = "am-aux1";
          break;
        default:
          if ((key.code >= 48 && key.code <=58) || key.description == '/') {
            cssClass = "am-numeric-strings";
          }
          break;
      }

    }
    else {
      switch (key.key) {
        case '':
        case '\n':
          cssClass = "am-width-medium-half";
          break;
        case 'space':
          cssClass = "am-space";
          break;
        case '\r':
        case '\tr':
          cssClass = "am-width-double2";
          break;
        case 'aux1':
          cssClass = "am-aux1";
          break;
        case 'aux2':
          cssClass = "am-aux1";
          break;
        default:
          if ((key.code >= 48 && key.code <=58) || key.description == '/') {
            cssClass = "am-numeric-strings";
          }
          break;
      }
    }
    return cssClass;
  }
/**
   * Método que valida la tecla presionada y realiza acciones en función de su tipo.
   *
   * @param {string} key - Tecla presionada.
   * @param {HTMLInputElement} inputRef - Referencia al campo de entrada asociado.
   * @return {void} No retorna ningún valor.
   */
  validateKey(key: string, inputRef: HTMLInputElement) {
    if (key) {
      if (key === '\tr' || (key && key.toUpperCase() === 'BACKSPACE')) {
        this.remove(inputRef.value);
      }
      else if (key === 'hide') {
        this.keyboarServ.destroy(true);
      }
      else {
        if (inputRef) {
          if(this.validadLen(inputRef.maxLength, this.currentCtrl))
            this.addKey(key, inputRef);
        }
      }
    }
  }
 /**
   * Método que elimina el último carácter del valor del campo de entrada.
   *
   * @param {string} value - Valor actual del campo de entrada.
   * @return {string} Valor actualizado del campo de entrada.
   */
  remove(value: string) {
    if(value.length >=0){
      value = value.slice(0, -1);
      this.currentCtrl.setValue(value);
    }

    return value;
  }
  /**
   * Método que agrega una tecla al valor del campo de entrada.
   *
   * @param {string} key - Tecla presionada.
   * @param {HTMLInputElement} inputValue - Referencia al campo de entrada asociado.
   * @return {void} No retorna ningún valor.
   */
  addKey(key: string, inputValue: HTMLInputElement) {
    const k = key ?  key.toUpperCase() : '';

    if ((key && key.toUpperCase() === 'SPACE')) {
      key = ' ';
    }

    if(k && (k !== '\tr' && k !== "BACKSPACE")) {
      const value = inputValue.value.toString() + key.toString()
      this.currentCtrl.setValue(value);
    }
  }
/**
   * Método que valida si el valor del campo de entrada no excede la longitud máxima permitida.
   *
   * @param {number} inputLen - Longitud máxima permitida.
   * @param {UntypedFormControl} control - Control de formulario asociado.
   * @return {boolean} `true` si el valor no excede la longitud máxima, `false` en caso contrario.
   */
  private validadLen( inputLen: number, control: UntypedFormControl): boolean {
    let isValid = true;
    inputLen = inputLen <= -1 ? 50 : inputLen;
    const len = control?.value?.length

    if(inputLen) {
      if(len >= inputLen)
        isValid = false;
    }

    return isValid;
  }


}
